<template>
	<div class="analytics-month" :class="`analytics-month--${andamento}`" :title="titolo">
		<div class="analytics-month__label">{{ etichetta }}</div>
		<div class="analytics-month__value">
			<v-icon v-if="andamento === 'up'" small color="success">mdi-arrow-up-bold</v-icon>
			<v-icon v-else-if="andamento === 'down'" small color="error">mdi-arrow-down-bold</v-icon>
			<span v-if="pending" class="grey--text">…</span>
			<span v-else>{{ formatK(value) }}</span>
		</div>
	</div>
</template>

<script>
import { formatK, etichettaMese, meseEsteso } from './format';

// Casella di un mese: valore (k per le migliaia) e freccia rispetto al mese prima
export default {
	name: 'MonthCell',
	props: {
		month: { type: String, required: true },
		value: { type: Number, default: 0 },
		// valore del mese prima; null per la prima casella (il mese prima e' fuori dai 12)
		previous: { type: Number, default: null },
		// mese non ancora scansionato da GA
		pending: { type: Boolean, default: false },
	},
	computed: {
		andamento() {
			if (this.pending || this.previous === null || this.value === this.previous) return 'same';
			return this.value > this.previous ? 'up' : 'down';
		},
		etichetta() {
			return etichettaMese(this.month);
		},
		titolo() {
			if (this.pending) return `${meseEsteso(this.month)}: in attesa della scansione`;
			const valore = `${meseEsteso(this.month)}: ${(this.value || 0).toLocaleString('it-IT')} visualizzazioni`;
			if (this.previous === null) return valore;
			return `${valore} (mese prima ${(this.previous || 0).toLocaleString('it-IT')})`;
		},
	},
	methods: { formatK },
};
</script>

<style scoped>
.analytics-month {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	padding: 4px 6px;
	min-width: 0;
	text-align: center;
}
.analytics-month--up {
	border-color: rgba(76, 175, 80, 0.6);
	background: rgba(76, 175, 80, 0.06);
}
.analytics-month--down {
	border-color: rgba(255, 82, 82, 0.6);
	background: rgba(255, 82, 82, 0.06);
}
.analytics-month__label {
	font-size: 11px;
	color: rgba(0, 0, 0, 0.6);
	white-space: nowrap;
}
.analytics-month__value {
	font-size: 14px;
	font-weight: 500;
	white-space: nowrap;
}
</style>
